import {
  Directive,
  ViewContainerRef,
  TemplateRef,
  ContentChildren,
  QueryList,
  Attribute,
  AfterContentInit,
  Input
} from '@angular/core';
import {isPresent, NumberWrapper} from '../facade/lang';
import {Map} from '../facade/collection';

import {SwitchView} from './ng_switch';

const _CATEGORY_DEFAULT = 'other';

/**
 * @experimental
 */
export abstract class NgLocalization { abstract getPluralCategory(value: any): string; }
export class NgPluralCase {
  /** @internal */
  _view: SwitchView;
  constructor( public value: string, template: TemplateRef<Object>,
              viewContainer: ViewContainerRef) {
    this._view = new SwitchView(viewContainer, template);
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: '[ngPluralCase]'}, ] },
];
static ctorParameters: {type: Function, decorators?: DecoratorInvocation[]}[] = [
{type: undefined, decorators: [{ type: Attribute, args: ['ngPluralCase', ] }, ]},
{type: TemplateRef, },
{type: ViewContainerRef, },
];
}
export class NgPlural implements AfterContentInit {
  private _switchValue: number;
  private _activeView: SwitchView;
  private _caseViews = new Map<any, SwitchView>(); cases: QueryList<NgPluralCase> = null;

  constructor(private _localization: NgLocalization) {}
  set ngPlural(value: number) {
    this._switchValue = value;
    this._updateView();
  }

  ngAfterContentInit() {
    this.cases.forEach((pluralCase: NgPluralCase): void => {
      this._caseViews.set(this._formatValue(pluralCase), pluralCase._view);
    });
    this._updateView();
  }

  /** @internal */
  _updateView(): void {
    this._clearViews();

    var view: SwitchView = this._caseViews.get(this._switchValue);
    if (!isPresent(view)) view = this._getCategoryView(this._switchValue);

    this._activateView(view);
  }

  /** @internal */
  _clearViews() {
    if (isPresent(this._activeView)) this._activeView.destroy();
  }

  /** @internal */
  _activateView(view: SwitchView) {
    if (!isPresent(view)) return;
    this._activeView = view;
    this._activeView.create();
  }

  /** @internal */
  _getCategoryView(value: number): SwitchView {
    var category: string = this._localization.getPluralCategory(value);
    var categoryView: SwitchView = this._caseViews.get(category);
    return isPresent(categoryView) ? categoryView : this._caseViews.get(_CATEGORY_DEFAULT);
  }

  /** @internal */
  _isValueView(pluralCase: NgPluralCase): boolean { return pluralCase.value[0] === "="; }

  /** @internal */
  _formatValue(pluralCase: NgPluralCase): any {
    return this._isValueView(pluralCase) ? this._stripValue(pluralCase.value) : pluralCase.value;
  }

  /** @internal */
  _stripValue(value: string): number { return NumberWrapper.parseInt(value.substring(1), 10); }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: '[ngPlural]'}, ] },
];
static ctorParameters: {type: Function, decorators?: DecoratorInvocation[]}[] = [
{type: NgLocalization, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'cases': [{ type: ContentChildren, args: [NgPluralCase, ] },],
'ngPlural': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
